var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.954V10.454H10.5V14.954H4.5ZM10.5 17.954H4.5V20.9863H10.5C10.5 20.9863 10.5 20.9863 10.5 20.9863V17.954ZM13.5 20.9863C13.5 20.9863 13.5 20.9863 13.5 20.9863V17.954H19.5V20.9863H13.5ZM13.5 14.954V10.454H19.5V14.954H13.5ZM13.5 7.45404H19.5V3H13.5V7.45404ZM10.5 3H4.5V7.45404H10.5V3ZM1.5 16.454V8.95404V2.99902C1.5 1.56488 2.5407 0 4.28571 0H19.7143C21.4593 0 22.5 1.56488 22.5 2.99902V8.95404V16.454V20.9873C22.5 22.4214 21.4593 23.9863 19.7143 23.9863H4.28571C2.5407 23.9863 1.5 22.4214 1.5 20.9873V16.454Z"
  })));
};
export default SvgTable;